<template>
  <div class="dragLayer scrollBar_xy" v-show="show" v-window-click="winClick">
    <!-- <div class="dragLayer-top">
      <span>图层</span>
      <div @click="hide">
        <i class="el-icon-close"></i>
      </div>
    </div> -->
    <draggable class="listUl" v-bind="dragOptions" v-model="showList">
      <!--排序的动画效果-->
      <transition-group tag="ul">
        <!--每一个报表的便利 别名-->
        <li :key="item.id" v-for="item in showList" @click="getNodeClick(item.id)" :class="{liActive:item.id === chart.id}">
          <span class="spaIn">{{item.index}}</span>
          <span class="spaNma" @dblclick="updInpId(item.id)" v-if="inp.id!==item.id"> {{item.name}}</span>
          <el-input @click.native.stop class="inputName" @keyup.enter.native="updInpName" v-model="inp.name" v-if="inp.id===item.id"></el-input>
          <div class="lockCls" v-if="item.isNoDrag">
            <FSvg title="锁定" IconSize="15" color="#000" hoverColor='#000' @click.native="unlockChart(item.id)"></FSvg>
          </div>
        </li>
      </transition-group>
    </draggable>
    <div class="dragBottom">
      <div>
        <FSvg title="删除" IconSize="17" color="#000" @click.native="removeChart"></FSvg>
      </div>
      <div>
        <FSvg title="复制" IconSize="20" color="#000" @click.native="copyChart"></FSvg>
      </div>
      <div>
        <FSvg title="锁定" IconSize="17" color="#000" @click.native="lockingChart"></FSvg>
      </div>
    </div>
    <!-- <div class="tuodong"></div> -->
  </div>
</template>

<script>
import { Guuid } from '@/assets/js/basis'
import modules from "../../../charts/script/modules";

export default {
  props: {
    show: {
      type: Boolean,
    }
  },
  components: {},
  data() {
    return {
      //修改名字 输入框配置
      inp: {
        id: null,
        name: ''
      },
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 300,
        group: "description",
        disabled: this.inp.id ? true : false,
      };
    },
    chartList: {
      get() {
        let data = [];
        this.$store.state.designer.chartList.map((item, index) => {
          data.push({
            name: (item.aliasName || item.name || '--'),
            id: item.id,
            isNoDrag: item.trans.isNoDrag,
            index: item.trans.z,
            check: false,
          })
        });
        data.sort((obj1, obj2) => {
          let val1 = obj1['index'];
          let val2 = obj2['index'];
          if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
          }
          if (val1 < val2) {
            return -1;
          } else if (val1 > val2) {
            return 1;
          } else {
            return 0;
          }
        }
        );
        return data;
      },
      set(data) {
        data.sort(this.sortChart);
        data.map((node, index) => {
          for (let item of this.$store.state.designer.chartList) {
            if (node.id === item.id) {
              item.trans.z = (index + 1);
              item.trans.isNoDrag = node.isNoDrag;
              item.aliasName = node.name;
              break;
            }
          }
        });
        return data;
      }
    },
    showList: {
      get() {
        let list = JSON.parse(JSON.stringify(this.chartList));
        return list.reverse();
      },
      set(data) {
        let list = JSON.parse(JSON.stringify(data));
        this.chartList = list.reverse();
        return data;
      }
    },
    chart() {
      return this.$store.state.designer.chart;
    },
  },
  methods: {
    hide() {
      this.$emit('update')
    },
    async winClick() {
      if (this.inp.id) {
        await this.updInpName();
      }
    },
    //拖拽
    // dragPanelMove(downDiv, moveDiv) {
    //   $(downDiv).mousedown(function (e) {
    //     let isMove = true;
    //     let div_x = e.pageX - $(moveDiv).offset().left;
    //     let div_y = e.pageY - $(moveDiv).offset().top;
    //     $(document).mousemove(function (e) {
    //       if (isMove) {
    //         let obj = $(moveDiv);
    //         let top = e.pageY - div_y;
    //         let left = e.pageX - div_x;
    //         if (top <= 0) {
    //           top = 0
    //         } else if (top >= $(document).height() - $(".dragLayer").height()) {
    //           top = $(document).height() - $(".dragLayer").height()
    //         }
    //         if (left <= 0) {
    //           left = 0
    //         } else if (left >= $(document).width() - $(".dragLayer").width()) {
    //           left = $(document).width() - $(".dragLayer").width()
    //         }
    //         obj.css({ "left": left, "top": top });
    //       }
    //     }).mouseup(
    //       function () {
    //         isMove = false;
    //       });
    //   });
    //   $(".tuodong").mousedown(function (e) {
    //     let isMove = true;
    //     let posix = {
    //       'w': $(".dragLayer").width(),
    //       'h': $(".dragLayer").height(),
    //       'x': e.pageX,
    //       'y': e.pageY
    //     };
    //     $(document).mousemove(function (e) {
    //       if (isMove) {
    //         let a = e.pageY - posix.y + posix.h;
    //         if (e.pageY - posix.y + posix.h >= 600) {
    //           a = 600;
    //         }
    //         $(".dragLayer").css({
    //           'height': Math.max(300, a)
    //         });
    //         return false;
    //       }
    //     }).mouseup(function () {
    //       isMove = false;
    //     });
    //   });
    // },
    //点击
    getNodeClick(id) {
      let data = null;
      for (let item of this.$store.state.designer.chartList) {
        if (item.id === id) {
          data = item;
          break;
        }
      }
      if (data) {
        this.$emit("noClick", data);
      }
    },
    //删除
    removeChart() {
      if (this.chart.id) {
        this.$store.state.designer.chartList.map((item, index) => {
          if (this.chart.id === item.id) {
            this.$store.state.designer.chartList.splice(index, 1);
          }
        });
        this.chartList.map((item, index) => {
          if (this.chart.id === item.id) {
            this.chartList.splice(index, 1);
          }
        });
        this.chartList.map((node, index) => {
          for (let item of this.$store.state.designer.chartList) {
            if (node.id === item.id) {
              item.trans.z = (index + 1);
              break;
            }
          }
        });
        this.$store.dispatch('screenClear');
      }
    },
    //隐藏
    hideChart() {

    },
    //锁定
    async lockingChart() {
      if (this.chart.id) {

        let count = 0;
        //获取当前第几个位置有锁定的图表
        let nowNoDragIndex = 0;
        this.chartList.map((node, index) => {
          if (node.isNoDrag) {
            nowNoDragIndex = (index + 1);
          }
        });
        //修改当前锁定 下标
        let updIndex = '';
        this.chartList.map((node, index) => {
          if (this.chart.id === node.id) {
            if (node.isNoDrag) {
              count = 1;
            }
            this.chartList[index].isNoDrag = true;
            updIndex = index;
          }
        });
        //把数组中某个对象移动到某个位置
        if ((updIndex || updIndex === 0) && count === 0) {
          this.chartList.sort(this.sortChart);
        }

        await this.$set(this, 'chartList', this.chartList);
        await this.$store.dispatch('screenSaveChart');
        await this.$store.dispatch('screenClear');
      }
    },
    //解锁
    async unlockChart(id) {
      if (id) {
        //修改当前锁定 下标
        let updIndex = '';
        this.chartList.map((node, index) => {
          if (id === node.id) {
            this.chartList[index].isNoDrag = false;
            updIndex = index;
          }
        });
        //获取当前第几个位置有锁定的图表
        let nowNoDragIndex = 0;
        this.chartList.map((node, index) => {
          if (node.isNoDrag) {
            nowNoDragIndex = (index + 1);
          }
        });
        //把数组中某个对象移动到某个位置
        if (updIndex || updIndex === 0) {
          this.chartList.sort(this.sortChart);
        }
        this.$set(this, 'chartList', this.chartList);
      }
    },
    //修改名字
    updInpId(id) {
      let name = '';
      for (let item of this.chartList) {
        if (id === item.id) {
          name = item.name;
          break;
        }
      }
      if (name) {
        this.inp.name = name;
        this.inp.id = id;
      }
    },
    //修改名字
    updInpName() {
      if (this.chart.id) {
        let count = 0;
        for (let item of this.chartList) {
          if (this.inp.id === item.id) {
            item.name = this.inp.name;
            count = 1;
            break;
          }
        }
        if (count !== 0) {
          this.inp.id = null;
          this.inp.name = '';
        }
        this.$set(this, 'chartList', this.chartList);
      }
    },
    //复制
    async copyChart() {
      if (this.chart.id) {
        let option = null;
        for (let item of this.$store.state.designer.chartList) {
          if (this.chart.id === item.id) {
            option = JSON.parse(JSON.stringify(item));
            break;
          }
        }
        if (option) {
          option.aliasName = (option.aliasName || option.name || '无名称') + '(复制)';
          option.trans.z = (this.$store.state.designer.chartList.length + 1);
          option.id = 'dp_' + option.class + '_' + Guuid();
          let charts = modules[option.type];
          option.component = charts.component;
          this.$store.state.designer.chartList.push(option);
          await this.$nextTick(async () => {
            await this.$store.dispatch('screenSaveChart');
            await this.$store.dispatch('screenClear');
            let charts = modules[option.type];
            await this.$store.dispatch('screenSwitchChart', { option, charts });
            if (option.dragType !== 1) {
              if (this.$store.state.designer.chart.option.isJSONConfig) {
                await this.$store.dispatch('screenValConvert');
              }
            }
            await this.$store.dispatch('screenRender');
          })
        }
      }
    },
    sortChart(d1, d2) {
      if (d1.isNoDrag && d2.isNoDrag) {
        return 0;
      } else if (d1.isNoDrag && !d2.isNoDrag) {
        return -1;
      } else if (!d1.isNoDrag && d2.isNoDrag) {
        return 1;
      }
    }
  },
  mounted() {
    // this.dragPanelMove(".dragLayer-top", ".dragLayer");
  }
}
</script>

<style lang="less">
.dragLayer {
  position: relative;
  top: 5px;
  //   right: 460px;
  // width: 298px;
  height: 320px;
  z-index: 1000;
  border-radius: 4px;
  //   overflow: hidden;

  .dragLayer-top {
    height: 40px;
    width: 100%;
    cursor: move;

    span {
      float: left;
      font-size: 15px;
      letter-spacing: 2px;
      margin: 12px 10px 0 10px;
    }

    div {
      float: right;
      margin: 10px 8px 0 10px;
      width: 20px;
      height: 20px;

      i {
        cursor: pointer;
        font-size: 20px;
        color: #fff;
      }

      i:hover {
        color: @green;
      }
    }
  }

  .updown {
    height: 30px;
    text-align: center;

    > div {
      cursor: pointer;
      display: inline-block;
      line-height: 28px;

      > .FSvg {
        margin: 0 10px;
      }
    }
  }

  .listUl {
    height: 287px;
    overflow: auto;

    li {
      padding: 0 15px;
      width: 100%;
      height: 35px;
      position: relative;
      cursor: pointer;
      white-space: nowrap;

      .spaIn {
        display: inline-block;
        height: 100%;
        line-height: 35px;
        font-size: 14px;
        letter-spacing: 1px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        float: left;
        max-width: 40px;
        min-width: 15px;
      }

      .spaNma {
        display: inline-block;
        height: 100%;
        line-height: 35px;
        font-size: 14px;
        letter-spacing: 1px;
        width: calc(100% - 60px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .inputName {
        width: calc(100% - 50px);
        margin-top: 4px;

        .el-input__inner {
          height: 27px;
          border: 1px solid #fff;
          line-height: 27px;
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
          background-color: transparent;
          letter-spacing: 1px;
          padding: 0 5px;
        }
      }

      .lockCls {
        float: right;
        height: 100%;
        line-height: 35px;
        text-align: center;
        color: #fff;
        width: 20px;
      }

      > input:focus {
        outline: none;
      }
    }
  }
  .listUl::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .listUl::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  /*定义滑块 内阴影+圆角*/
  .listUl::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }
  .dragBottom {
    // width:298px;
    height: 33px;
    // position: absolute;
    // bottom: 0;
    text-align: right;

    > div {
      cursor: pointer;
      display: inline-block;
      line-height: 33px;

      > .FSvg {
        margin-right: 10px;
      }
    }
  }

  .tuodong {
    width: 100%;
    height: 5px;
    position: absolute;
    bottom: 0;
    right: 0;
    cursor: s-resize;
  }

  /* - - -- - -- - -- - -- - -- - -  颜色- - -- - -- - -- - -- - -- - -- - -*/

  .dragLayer {
    background-color: #191c24;
    box-shadow: 0 0 10px #191c24;
    border: 1px solid #232d39;
  }

  .updown {
    border-bottom: 1px solid #232d39;
    background-color: #142f49;

    svg {
      fill: #eee;
    }
  }

  .dragLayer-top {
    background-color: #232d39;
    color: #ddd;

    svg {
      fill: #eee;
    }
  }

  .listUl {
    border-top: 2px solid rgba(0, 39, 116, 0.25);
    // background-color: #142f49;
    background-color: #e7e9ee;

    ul {
      width: 100%;
      height: 100%;

      > li {
        border-bottom: 1px solid rgba(0, 39, 116, 0.25);

        span,
        input {
          color: #000;
        }

        svg {
          fill: #eee;
        }

        &:hover,
        &.active {
          background-color: rgba(19, 181, 177, 0.15);
        }
      }

      .liActive {
        background-color: rgba(19, 181, 177, 0.4) !important;
      }
    }
  }

  .dragBottom,
  .tuodong {
    background: #e7e9ee;

    svg {
      fill: #eee;
    }
  }
}
</style>
